import { __assign } from "tslib";
import ChatSdkError from '../domain/chat-sdk-error';
import { HttpClient } from '@wix/http-client';
var createHttpClient = function (options) { return new HttpClient(options); };
export var httpClientRequestHandlerProvider = function (initConfig) {
    var httpClient = createHttpClient(__assign(__assign({}, initConfig), { baseURL: initConfig.baseURL || '/' }));
    return function (requestConfig) {
        return httpClient.request(requestConfig).catch(function (error) {
            throw new ChatSdkError(error, ChatSdkError.TYPES.HTTP_REQUEST);
        });
    };
};
